export const environment = {
  production: true,
  fullImgPath: '../../../assets/img/',
  baseURL: 'https://fulfillment.dev.ztarmobile.io',
  siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
}